export default __webpack_public_path__ + "static/media/Aura-Egg__34.be34f0bc.png";